const DEFAULT_TITLE = "Intygsläkaren – Digitala Läkarintyg snabbt och professionellt";
const DEFAULT_DESCRIPTION =
  "Intygsläkaren utfärdar digitala läkarintyg för körkort, sjöfolk, arbete, resor, försäkring och mer. Boka tid online – snabbt, smidigt och professionellt.";

type PageMetaState = {
  title: string;
  description: string;
};

let current: PageMetaState = {
  title: DEFAULT_TITLE,
  description: DEFAULT_DESCRIPTION,
};

export const publishPageMeta = (title: string, description: string) => {
  current = {
    title: title.slice(0, 60),
    description: description.slice(0, 160),
  };
};

export const readPageMeta = (): PageMetaState => current;

export const resetPageMeta = () => {
  current = {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
  };
};
